import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { AuthModal } from "./components/AuthModal";
import { HomePage } from "./pages/HomePage";
import { ProductsPage } from "./pages/ProductsPage";
import { ProductDetailPage } from "./pages/ProductDetailPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { CheckoutSuccessPage } from "./pages/CheckoutSuccessPage";
import { AccountPage } from "./pages/AccountPage";
import { AdminPage } from "./pages/AdminPage";
import { ServingSuggestionsPage } from "./pages/ServingSuggestionsPage";
import { MocktailsPage } from "./pages/MocktailsPage";
import { useAuthStore, useCartStore } from "./lib/store";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const { isAuthenticated } = useAuthStore();
  const { fetchCart } = useCartStore();

  useEffect(() => {
    // Seed initial data
    const seedData = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (error) {
        // Data may already be seeded
      }
    };
    seedData();
  }, []);

  useEffect(() => {
    // Fetch cart when authenticated
    if (isAuthenticated) {
      fetchCart();
    }
  }, [isAuthenticated, fetchCart]);

  const handleAuthClick = () => setAuthModalOpen(true);

  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar onAuthClick={handleAuthClick} />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage onAuthClick={handleAuthClick} />} />
            <Route path="/products" element={<ProductsPage onAuthClick={handleAuthClick} />} />
            <Route path="/products/:id" element={<ProductDetailPage onAuthClick={handleAuthClick} />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/serving-suggestions" element={<ServingSuggestionsPage />} />
            <Route path="/mocktails" element={<MocktailsPage />} />
          </Routes>
        </main>
        <Footer />
        <AuthModal open={authModalOpen} onClose={() => setAuthModalOpen(false)} />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
